"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _Icon = _interopRequireDefault(require("../Icon"));

var _jsxRuntime = require("react/jsx-runtime");

var UploadFooterView = function UploadFooterView(props) {
  var submitButton = /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    className: "large primary inline-container".concat(props.isSubmittable ? '' : ' disabled'),
    id: "submit",
    type: "submit",
    disabled: props.submitted,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
      value: "action.confirm"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      icon: props.submitted ? 'loader' : 'check'
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "actions col-12 inline-container space-between",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      className: "large secondary inline-container",
      onClick: props.onCancelClick,
      "data-id": "cancel",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "action.cancel"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "go-back"
      })]
    }), props.isSubmittable ? submitButton : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      tooltip: _reactReduxI18n.I18n.t('message.missingRequiredFields'),
      flow: "left",
      children: submitButton
    })]
  });
};

UploadFooterView.propTypes = {
  isSubmittable: _propTypes.default.bool.isRequired,
  submitted: _propTypes.default.bool.isRequired,
  onCancelClick: _propTypes.default.func
};
var _default = UploadFooterView;
exports.default = _default;
//# sourceMappingURL=UploadFooterView.js.map